import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight, faFilePdf } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

export interface Resource {
  id: string;
  title: string;
  youtube?: string;
  downloadUrl?: string;
  subtitle: string;
  icon: IconProp;
  link?: string;
  image?: boolean;
  customComponent?: () => JSX.Element;
  type: ResourceType;
}

export enum ResourceType {
  Pdf = 'Pdf',
  Images = 'Images',
  Video = 'Video',
  GoogleDrive = 'GoogleDrive',
}

export type TabsData = Record<string, { title: string; items: Resource[] }>;

export type OpenSections = Record<string, boolean>;

export function formatMinutes(totalMinutes: number): string {
  const numberFormatter = new Intl.NumberFormat('en', {
    minimumIntegerDigits: 1,
    maximumFractionDigits: 0,
  });

  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  const hoursText =
    hours > 0
      ? `${numberFormatter.format(hours)} hour${hours > 1 ? 's' : ''}`
      : '';
  const minutesText =
    remainingMinutes > 0
      ? `${numberFormatter.format(remainingMinutes)} minute${remainingMinutes > 1 ? 's' : ''}`
      : '';
  return [hoursText, minutesText].filter(Boolean).join(' ');
}

export const useResourceObject = () => {
  const { t } = useTranslation();
  return {
    tabsData: {
      [t('All')]: { title: 'All', items: [] },
      Pdf: {
        title: 'Pdf',
        items: [
          {
            id: '1',
            title: 'Affiliate Presentation',
            subtitle: 'Download the Affiliate Presentation',
            icon: faFilePdf,
            downloadUrl:
              'https://monevis-cdn.s3.eu-central-1.amazonaws.com/Monevis_Affiliate_2025.pdf',
            type: ResourceType.Pdf,
          },
        ],
      },
      SocialMediaContent: {
        title: 'Social Media Content',
        items: [
          {
            id: '1',
            title: 'Premium Social Media Promo Pack',
            subtitle: '40 premium files',
            icon: faArrowRight,
            downloadUrl:
              'https://drive.google.com/drive/folders/1a0GMwDwDTOmvh8K66CPp9edsM0MN1Z-4?usp=drive_link',
            type: ResourceType.GoogleDrive,
          },
        ],
      },
      Videos: {
        title: 'Videos',
        items: [
          {
            id: '1',
            title: 'Promo video horizontal',
            link: '/images/aff-horizontal-video.png',
            image: true,
            subtitle: `Video - ${formatMinutes(2)}`,
            downloadUrl:
              'https://drive.google.com/file/d/10xjyFyiscjF9RsJ99wlQbBB8DJzd1IjN/view?usp=drive_link',
            type: ResourceType.Video,
          },
          {
            id: '2',
            title: 'Promo video vertical',
            subtitle: `Video - ${formatMinutes(3)}`,
            link: '/images/aff-vertical-video.png',
            image: true,
            downloadUrl:
              'https://drive.google.com/file/d/1ISnjaJXNQYaQg2Qs45puPyWOpgSq2UaJ/view?usp=drive_link',
            type: ResourceType.Video,
          },
        ],
      },
    } as TabsData,
    openSections: {
      SocialMediaContent: true,
      Videos: true,
      Pdf: true,
    } as OpenSections,
  };
};
